<template>
    <div>
        <b-modal title="পানির সংযোগ হালনাগাদ আবেদন ফরম" no-close-on-backdrop hide-footer size="lg"  v-model="largeModal" >
            <form @submit.prevent="addApplication">

                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">মোবাইল নম্বর</label>
                    <div class="col-sm-4">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                    </div>
                    <label  class="col-sm-2 col-form-label">এন.আই.ডি নম্বর</label>
                    <div class="col-sm-4">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">নাম</label>
                    <div class="col-sm-4">
                        <input name="Name" disabled v-validate="'required'"   type="text"  v-model="user.name" class="form-control"  placeholder="নাম">
                    </div>
                    <label class="col-sm-2 col-form-label">জন্ম তারিখ</label>
                    <div class="col-sm-4">
                        <input type="date" disabled v-model="user.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">হোল্ডিং নং </label>
                    <div class="col-sm-4">
                        <select disabled v-validate="'required'" @change="getHoldingName()" v-model="application.holding_id" name="Hoding" class="form-control">
                            <option :value="holding.id" v-for="(holding,key) in holdings" :key="key">{{holding.name}}</option>
                        </select>
                        <p v-show="errors.has('Hoding')"  style="color:red">* {{ errors.first('Hoding') }}</p>
                    </div>
                    <label class="col-sm-2 col-form-label">লাইনের ব্যাস <span class="required">*</span></label>
                    <div class="col-sm-4">
                        <select v-validate="'required'" @change="serviceCharge()" v-model="application.service_id" name="Diameter" class="form-control">
                            <option :value="diameter.id" v-for="(diameter,key) in diameter_list" :key="key">{{diameter.name}}&nbsp;{{diameter.diameter}}ইঞ্চি</option>
                        </select>
                        <p v-show="errors.has('Diameter')"  style="color:red">* {{ errors.first('Diameter') }}</p>
                    </div>
                </div>
                <div v-if="$user.type != 2" class="form-group row">
                    <label class="col-sm-2 col-form-label">অনুমোদন ডকুমেন্ট <span class="required">*</span></label>
                    <div class="col-sm-4">
                        <input
                            v-validate="'required|size:2048'"
                            name="Document"
                            type="file"
                            ref="ImageFile"
                            class="file-input"
                            v-on:change="imageChanged"
                        />
                        <p v-show="errors.has('Document')"  style="color:red">* {{ errors.first('Document') }}</p>
                    </div>
                    <label class="col-sm-2 col-form-label">অ্যাডজাস্টমেন্ট</label>
                    <div class="col-sm-2">
                        <select @change="adjust(question)" v-model="adjustment_type" class="form-control">
                            <option value="">প্রকার</option>
                            <option value="1">অতিরিক্ত ফি</option>
                            <option value="2">কম ফি</option>
                        </select>
                    </div>
                    <div class="col-sm-2">
                        <input  type="number" v-model="question" min="0"  class="form-control">
                    </div>
                </div>
                 <div class="form-group row">
                    <div style="border-top:1px solid #bbc3ca" class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-6">

                            </div>
                            <div class="col-sm-6">
                                <div class="row mt-1">
                                    <div class="col-sm-6">হালনাগাদ ফি</div><div class="col-sm-6">: <b>{{application_fee}}</b></div>
                                    <div class="col-sm-6">অ্যাডজাস্টমেন্ট</div><div class="col-sm-6">: <b>{{application.adjustment}}</b></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-6"></div>
                    <div style="border-top:1px solid #bbc3ca" class="col-sm-6">
                        <div class="row mt-1">
                            <div class="col-sm-6">মোট হালনাগাদ ফি</div><div class="col-sm-6">: <b>{{application.fee}}</b></div>
                            <div class="col-sm-6">মাসিক বিল</div><div class="col-sm-6">: <b>{{application.monthly_bill}}</b></div>
                        </div>
                    </div>
                </div>
                <br> <br>
                <div class="form-group row">
                    <div class="col-sm-12">
                    <input type="submit" value="submit" v-if="!addApplicationLoader"  class="btn btn-primary pull-right">
                    <button v-if="! addApplicationLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    <button v-if="addApplicationLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)
export default {
    data(){
        return{
            question:0,
            servererrors:{},
            addApplicationLoader:false,
            index:'',
            largeModal:false,
            holdings:[],
            diameter_list:[],
            check:false,
            user:{
                id:'',
                name:'',
                nid:'',
                mobile_number:'',
                birthday:''
            },
            application_fee:0,
            application:{
                fee:0,
                monthly_bill:0,
                adjustment:0,
                holding_id:'',
                service_id:'',
                adjustment_type:'',
                holding_name:'',
                type:'update-water-connection',
                account_id:'',
                not_edit_file:'',
                file:''
            },
            user_data:{
                application:{
                    service:{
                        id:''
                    }
                }
            },
            my_title: 'পানির সংযোগ হালনাগাদ',
            type: 'update-water-connection',
            adjustment_type:'',
            service_list:[],
        }
    },
    watch:{
        question: function (){
            this.application.adjustment = parseInt(this.question)
            this.adjust(parseInt(this.question))
        }
    },
    methods:{
        imageChanged(e) {
            var fileReader = new FileReader()
            fileReader.readAsDataURL(e.target.files[0])
            fileReader.onload = e => {
                this.application.file = e.target.result
                this.application.not_edit_file = 11
            }
            this.check = false
            // this.url = URL.createObjectURL(e.target.files[0])
        },
        getHoldingName(){
            var self = this
            this.holdings.forEach(element=>{
                if(element.id == self.application.holding_id){
                    self.application.holding_name = element.name
                }
            })
        },
        adjust(adjustment = 0){
            this.application.adjustment =  adjustment
            var self = this
            if(self.adjustment_type){
                if(self.adjustment_type == 1){
                    self.application.adjustment =  parseInt(self.application.adjustment)
                    self.application.adjustment_type = 'positive'
                }
                else if(self.adjustment_type == 2){
                    self.application.adjustment =  parseInt(-self.application.adjustment)
                    self.application.adjustment_type = 'negative'
                }
            }
            else{
                self.application.adjustment =  0
                self.application.adjustment_type = 'positive'
            }

            self.application.fee = self.application_fee + self.application.adjustment
        },
        serviceCharge(){
            var self = this

            this.diameter_list.forEach(element=>{
                if(element.id == self.application.service_id){
                    self.application_fee = element.update_fee
                    self.application.fee = self.application_fee + self.application.adjustment
                    self.application.monthly_bill = element.price
                }
            })
        },
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
        close(){
            this.largeModal = false
        },
        addApplication () {
            if(this.$user.type !=1){
                this.application.file = true
                this.application.not_edit_file = 10
            }

            this.check = true
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.check = false
                    this.application.user_id = this.user.id;
                    var data = this.application
                    //console.log(this.application)
                    this.addApplicationLoader = true;
                    this.$store.dispatch('ADD_APPLICATION',data)
                    .then(response=>{
                        this.addApplicationLoader=false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addApplicationLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })

        },
        openModal(user_data){
            //console.log('ok')
            this.check = false
            this.application.file = ''
            this.user_data = user_data
            this.index = ''
            this.largeModal = true
            this.user = user_data.user
            this.holdings = user_data.holding
            this.diameter_list = user_data.project
            //this.application.holding_id = user_data.application.holding.id
            this.application.service_id = user_data.application.service.id
            this.application.monthly_bill = user_data.application.service.price
            this.application.account_id = user_data.application.id
            this.application.fee  = user_data.application.service.update_fee
            this.application_fee = this.application.fee
            //this.getSelectService(this.application.select_dia)
            //console.log(user_data)

        },
    },
    computed:{

    },

}
</script>

<style>
.custom_modal_body{
    overflow: auto;
    min-height: auto;
}
.required{
    color: red;
}
</style>
